import React from 'react'
import classnames from 'classnames'

import config from 'config'
import { useQuery } from 'hooks'
import { apiManager } from 'helpers'

import DefaultButton from 'components/Button'
import Ranking from './Ranking'

const Button = ({ className, primary, children, ...rest }) => (
  <DefaultButton
    className={classnames(
      className,
      'w-full text-lg rounded-lg h-14 relative z-10 focus:ring-white',
      {
        'bg-white': primary,
        'border border-solid border-white border-opacity-30 ': !primary,
      }
    )}
    {...rest}
    style={{
      background:
        primary &&
        `linear-gradient(177.65deg, #FFFFFF 1.96%, #C0CEFF 98.03%),linear-gradient(0deg, #FFFFFF, #FFFFFF),linear-gradient(0deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0.15))`,
    }}
  >
    <span
      className={classnames('font-medium', {
        'text-black': primary,
      })}
    >
      {children}
    </span>
  </DefaultButton>
)
const AcceptedMember = ({ user }) => {
  const { data } = useQuery('user/waitlist', apiManager.getUserWaitlist)

  if (!user.seenWelcomeSequence) {
    // return null
  }

  return (
    <div className="relative flex flex-col items-center justify-center text-white max-w-lg w-full mx-auto px-4 pt-6 md:pt-0 overflow-auto">
      <div className="text-2xl mb-10 font-semibold font-ownersWide max-w-sm text-center px-4">
        <>
          YOU'RE ACCEPTED <br />
          Download the app to explore <br />
          The TELEPORT Universe
        </>
      </div>
      <div className="relative w-full mb-20">
        {data?.position && (
          <Ranking
            name={user.name}
            image={user.profileImage}
            points={user.points}
            position={data.position}
            me={true}
          />
        )}
      </div>
      <Button
        className="mb-4"
        primary={true}
        onClick={() => window.open(config.ios.appLink, '_blank')}
      >
        Download App
      </Button>
      <div className="text-lg text-center px-4 opacity-50 mb">Attract, don’t chase.</div>
    </div>
  )
}

export default AcceptedMember
